import React, { useState } from "react";
import { Link } from "react-router-dom";
import { pickFormationText } from "./karateFormationLocale.js";

/**
 * @param {object} props
 * @param {Array} props.screens
 * @param {number} props.initialScreen
 * @param {'fr'|'en'} props.locale
 * @param {object} props.ui
 * @param {(payload: object) => Promise<void>} props.onUpdate
 * @param {() => void} props.onClose
 */
export function KarateFormationDiscovery({ screens, initialScreen = 0, locale, ui, onUpdate, onClose }) {
  const [index, setIndex] = useState(initialScreen);
  const screen = screens[index];
  const isLast = index >= screens.length - 1;

  async function finish(skipped = false) {
    await onUpdate(skipped ? { skipped: true } : { completed: true });
    await onClose?.();
  }

  return (
    <div className="karate-formation-discovery" data-testid="formation-discovery-overlay" role="dialog" aria-modal="true">
      <div className="karate-formation-discovery__panel">
        <p className="karate-formation-discovery__step">
          {index + 1} / {screens.length}
        </p>
        <h2>{pickFormationText(screen?.title, locale)}</h2>
        <p>{pickFormationText(screen?.body, locale)}</p>
        {screen?.link ? (
          <p className="karate-formation-discovery__link">
            <Link to={pickFormationText(screen.link, locale) || screen.link.fr}>
              {pickFormationText(screen.link.label, locale)}
            </Link>
          </p>
        ) : null}
        <div className="karate-formation-discovery__actions">
          <button type="button" className="btn-primary-outline" data-testid="formation-discovery-skip" onClick={() => finish(true)}>
            {ui.skip}
          </button>
          {index > 0 ? (
            <button
              type="button"
              className="btn-primary-outline"
              data-testid="formation-discovery-prev"
              onClick={() => {
                const next = index - 1;
                setIndex(next);
                onUpdate({ currentScreen: next });
              }}
            >
              {ui.previous}
            </button>
          ) : null}
          {!isLast ? (
            <button
              type="button"
              className="btn-primary"
              data-testid="formation-discovery-next"
              onClick={() => {
                const next = index + 1;
                setIndex(next);
                onUpdate({ currentScreen: next });
              }}
            >
              {ui.next}
            </button>
          ) : (
            <button type="button" className="btn-primary" data-testid="formation-discovery-start" onClick={() => finish(false)}>
              {ui.start}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
